module.exports = __webpack_public_path__ + "static/media/defaultImg.8a5f0958.svg";